//@ts-ignore
import { ICommonGridColumn } from '@broadleaf/admin-components/dist/types/common';
import { unstable } from '@broadleaf/admin-components';
import { get } from 'lodash';
import { createPath } from 'history';

const { SimpleIcon } = unstable;

export const RowValueLinkColumn: React.FC<RowValueLinkProps> = props => {
  const { title, link, newTab } = getRowValueLinkProps(props);
  const linkProps = {
    to: link,
    title,
    target: undefined,
    rel: undefined
  };
  if (newTab) {
    const href = link;
    linkProps.target = '_blank';
    linkProps.rel = href.startsWith('/') ? undefined : 'noopener noreferrer';
  }
  return (
    <div>
      {link ? (
        <RowLink
          className="tw-flex tw-items-center tw-font-semibold tw-text-link-600 hover:tw-text-link-700"
          to={linkProps.to}
          title={linkProps.title}
          target={linkProps.target}
          rel={linkProps.rel}
        >
          <span>{title}</span>
          {newTab && (
            <SimpleIcon className="tw-ml-2" iconName="external-link-alt" />
          )}
        </RowLink>
      ) : (
        <span title={title}>{title}</span>
      )}
    </div>
  );
};

const RowLink = ({ to, children, ...rest }) => {
  const href = typeof to === 'string' ? to : createPath(to);
  return (
    <a
      className="Link tw-font-medium disabled:tw-pointer-events-none"
      {...rest}
      href={href}
    >
      {children ? children : href}
    </a>
  );
};

function getRowValueLinkProps(props: RowValueLinkProps): LinkValueProps {
  const { header, row } = props;
  const title = get(row, header.name);
  // The field containing the link. This should be a full URL or a path.
  const linkField = get(header, 'attributes.linkField');
  const link = linkField ? get(row, linkField) : null;
  const newTab = get(header, 'attributes.newTab', true);
  return { title, link, newTab };
}

export interface LinkValueProps {
  link?: string;
  newTab: boolean;
  title: string;
}

export interface RowValueLinkProps extends ICommonGridColumn {}
